import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Typography } from "@material-tailwind/react";

import { sdkWrapperURL, token } from "../utils/api-url-list";

const DownloadReport = () => {
  const { t, i18n } = useTranslation("Report");
  const navigate = useNavigate();
  const { state } = useLocation();
  const scan_id = state?.scan_id;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [hasConsent, setConsent] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [reportSent, setReportSent] = useState(false);

  const requestReport = async () => {
    setLoading(true);
    try {
      const trim_email = email.toLowerCase().trim();
      setEmail(trim_email);
      const trim_name = name.trim();
      setName(trim_name);
      if (trim_email.length <= 0 || trim_name.length <= 0)
        throw new Error("Invalid Form Data");
      const reportResp = await fetch(
        sdkWrapperURL("/users/sdk/manual-report"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            scan_id,
            notes: {
              report_slug: i18n.resolvedLanguage.toUpperCase(),
              report_webhook_config: {
                tags: [{ name: "patient_name", value: trim_name }],
              },
            },
            email: trim_email,
          }),
        }
      );
      const reportRespJSON = await reportResp.json();
      if (reportRespJSON?.statusCode?.toString().startsWith("2"))
        setReportSent(true);
      else
        throw new Error(
          reportRespJSON?.message ?? "Error in Fetching the Scan Token"
        );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return scan_id?.length > 0 ? (
    <section className="shrink-0 grow px-[10%]">
      <Typography
        variant="h5"
        className="mb-8 sm:mb-12 sm:text-2xl text-secondary text-center"
      >
        {t("DownloadReport")}
      </Typography>
      {reportSent ? (
        <Typography
          variant="lead"
          className="my-32 text-lg sm:text-2xl text-center text-primary"
        >
          {t("success")}
        </Typography>
      ) : (
        <>
          <Typography
            variant="h6"
            className="mb-4 sm:mb-8 sm:text-xl text-secondary"
          >
            {t("EnterName")}
          </Typography>
          <input
            className="block relative mb-8 sm:mb-24 w-full p-4 rounded-lg outline-none border border-stroke bg-white text-sm sm:text-lg text-primary"
            type="text"
            name="name"
            id="name"
            placeholder="John Doe"
            autoComplete="off"
            inputMode="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Typography
            variant="h6"
            className="mb-4 sm:mb-8 sm:text-xl text-secondary"
          >
            {t("EnterEmail")}
          </Typography>
          <input
            className="block relative mb-8 sm:mb-24 w-full p-4 rounded-lg outline-none border border-stroke bg-white text-sm sm:text-lg text-primary"
            type="email"
            name="email"
            id="email"
            placeholder="johndoe@mail.com"
            autoComplete="off"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Checkbox
            id="consent"
            name="consent"
            color="red"
            label={t("consent")}
            labelProps={{ className: "text-primary text-[10px] sm:text-sm" }}
            containerProps={{ className: "shrink-0" }}
            className="border border-stroke bg-white"
            ripple={true}
            value={hasConsent}
            checked={hasConsent}
            onChange={(e) => setConsent(e.target.checked)}
          />

          <Button
            color="white"
            className="mt-10 w-full bg-primary text-white border border-primary text-sm sm:text-lg font-medium normal-case"
            disabled={!hasConsent || isLoading}
            onClick={requestReport}
          >
            {t("DownloadReport")}
          </Button>
        </>
      )}
      <div className="mt-8 mb-4 flex items-stretch justify-between gap-8">
        <Button
          color="white"
          className="flex-1 bg-white text-primary/80 border border-stroke text-sm sm:text-lg font-medium normal-case"
          onClick={() => {
            navigate("/", { replace: true });
          }}
        >
          {t("Cancel")}
        </Button>
        <Button
          color="white"
          className="flex-1 bg-white text-primary/80 border border-stroke text-sm sm:text-lg font-medium normal-case"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("Back")}
        </Button>
      </div>
    </section>
  ) : (
    <Navigate to="/" replace />
  );
};

export default DownloadReport;
